








import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { Component, Vue } from "vue-property-decorator";
@Component
export default class App extends Vue
{
    /**
     * 本地化
     * @protected
     * @returns any
     */
    protected locale: any = zhCN;

}
